const KEY = "postLoginRedirect";

/**
 * Remembers where the user was headed before being bounced to /inituser to
 * authenticate. Kept in sessionStorage because the MSAL/ADFS login is a
 * full-page redirect round-trip — router state doesn't survive it, but
 * sessionStorage does (per tab).
 */
export function setPostLoginRedirect(path) {
  if (
    path &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    path !== "/inituser"
  ) {
    sessionStorage.setItem(KEY, path);
  }
}

/**
 * Returns the stored destination (once) and clears it, or null if none.
 * Only ever returns app-internal paths.
 */
export function consumePostLoginRedirect() {
  const path = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (path && path.startsWith("/") && !path.startsWith("//")) {
    return path;
  }
  return null;
}
